import styled from 'styled-components'
import { containerHeadline } from '../../../lib/styles/Container'

export const StyledBlogFooter = styled.div`
  ${containerHeadline};
  margin: 0 auto;
  display: flex;
  flex-direction: column;
`
